import { render, staticRenderFns } from "./HospitalizedContentPage.vue?vue&type=template&id=290fecea"
import script from "./HospitalizedContentPage.vue?vue&type=script&lang=js"
export * from "./HospitalizedContentPage.vue?vue&type=script&lang=js"
import style0 from "./HospitalizedContentPage.vue?vue&type=style&index=0&id=290fecea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports